import {
  withValidation,
  composeSDKFactories,
  createElementPropsSDKFactory,
  changePropsSDKFactory,
  clickPropsSDKFactory,
  childrenPropsSDKFactory,
  focusPropsSDKFactory,
  toJSONBase,
} from '@wix/editor-elements-corvid-utils';
import { createComponentSDKModel } from '@wix/editor-elements-integrations/corvid';
import type {
  ISingleTabPlatformProps,
  ISingleTabSDK,
  ISingleTabSDKFactory,
} from '../SingleTab.types';

const singleTabSDKFactory: ISingleTabSDKFactory = ({
  props,
  setProps,
  metaData,
}) => ({
  get label() {
    return props.label;
  },
  set label(value) {
    const { compId, getParent } = metaData;
    const tabsComp = getParent();
    setProps({ label: value });
    tabsComp._setTabLabel(compId, value);
  },
  toJSON() {
    const { label } = props;
    return {
      ...toJSONBase(metaData),
      label,
    };
  },
});

const singleTab = withValidation(singleTabSDKFactory, {
  type: ['object'],
  properties: {
    label: {
      type: ['string'],
      maxLength: 120,
    },
  },
});

export const sdk = composeSDKFactories<ISingleTabPlatformProps, ISingleTabSDK>([
  createElementPropsSDKFactory(),
  changePropsSDKFactory,
  clickPropsSDKFactory,
  childrenPropsSDKFactory,
  focusPropsSDKFactory,
  singleTab,
]);

export default createComponentSDKModel(sdk);
